import { all, call, put, takeLatest } from 'redux-saga/effects';
import { domainMap, domainName } from '../../config';
import apiJunction from '../../utils/api';
import * as types from './actionTypes';
import {
    accStatusFailure,
    accStatusSuccess,
    activationPrecheckFailure,
    activationPrecheckSuccess,
    changePlanFailure,
    changePlanSuccess,
    customerGroupFailure,
    customerGroupSuccess,
    dataCutOffFailure,
    dataCutOffSuccess,
    getCreditFailure,
    getCreditSuccess,
    otpFailure,
    otpSuccess,
    planChangeCustomerStatusFailure,
    planChangeCustomerStatusSuccess,
    referalCreditFailure,
    referalCreditSuccess,
    topUpCustomerFailure,
    topUpCustomerStatusFailure,
    topUpCustomerStatusSuccess,
    topUpCustomerSuccess,
    topUpFailure,
    topUpGroupFailure,
    topUpGroupSuccess,
    topUpPulseFailure,
    topUpPulseSuccess,
    topUpSuccess,
    type4TaxFailure,
    type4TaxSuccess,
} from './actions';
import ApiEndPoints from '../../utils/ApiEndPoints';

export interface ResponseGenerator {
    config?: any;
    data?: any;
    headers?: any;
    request?: any;
    status?: number;
    statusText?: string;
}

// datacutt off
function* dataCutOff(action: any) {
    try {
        const response: ResponseGenerator = yield call(apiJunction.makeRequest, {
            method: 'post',
            url: `${ApiEndPoints.dataCutOff}`,
            body: action.payload,
        });
        yield put(
            dataCutOffSuccess({
                dataCutOff: response.data,
            }),
        );
    } catch (err: any) {
        yield put(
            dataCutOffFailure({
                errorDataCutOff: err.response && err.response.data,
            }),
        );
    }
}

// top up
function* topUp(action: any) {
    try {
        const response: ResponseGenerator = yield call(apiJunction.makeRequest, {
            method: 'post',
            url:
                domainName === domainMap.T2
                    ? `${ApiEndPoints.topUp}`
                    : `${ApiEndPoints.topUp}`,
            body: action.payload,
        });
        yield put(
            topUpSuccess({
                topUp: response.data,
            }),
        );
    } catch (err: any) {
        yield put(
            topUpFailure({
                errorTopUp: err.response ? err.response.data : { status: 'FAILURE', message: 'error' },
            }),
        );
    }
}

// top up
function* topUpPulse() {
    try {
        const response: ResponseGenerator = yield call(apiJunction.makeRequest, {
            method: 'get',
            url: domainName === domainMap.T2 ? `${ApiEndPoints.topUpPulse}` : `${ApiEndPoints.topUpPulse}`,
        });
        yield put(
            topUpPulseSuccess({
                topUpPulse: response.data,
            }),
        );
    } catch (err: any) {
        yield put(
            topUpPulseFailure({
                errorTopUpPulse: err.response && err.response.data,
            }),
        );
    }
}

// customer Group
function* customerGroup(action: any) {
    try {
        const response: ResponseGenerator = yield call(apiJunction.makeRequest, {
            method: 'get',
            url:
                domainName === domainMap.T2
                    ? `${ApiEndPoints?.customerGroup}/${action.payload.groupId}`
                    : `${ApiEndPoints?.customerGroup}/${action.payload.groupId}`,
        });
        yield put(
            customerGroupSuccess({
                group: response.data,
            }),
        );
    } catch (err: any) {
        yield put(
            customerGroupFailure({
                errorGroup: err.response && err.response.data,
            }),
        );
    }
}

// Activation Precheck
function* activationPrecheck(action: any) {
    try {
        const response: ResponseGenerator = yield call(apiJunction.makeRequest, {
            method: 'get',
            url:
                domainName === domainMap.T2
                    ? `${ApiEndPoints.activationPreCheck}/${action.payload.id}`
                    : `${ApiEndPoints.activationPreCheck}/${action.payload.id}`,
        });
        yield put(
            activationPrecheckSuccess({
                activationPrecheck: response.data,
            }),
        );
    } catch (err: any) {
        yield put(
            activationPrecheckFailure({
                errorActivationPrecheck: err.response && err.response.data,
            }),
        );
    }
}

// top up Group
function* topUpGroup(action: any) {
    try {
        const response: ResponseGenerator = yield call(apiJunction.makeRequest, {
            method: 'get',
            url:
                domainName === domainMap.T2
                    ? `${ApiEndPoints?.topUpGroup}/${action.payload.groupId}?startDate=${action.payload.startDate}&endDate=${action.payload.endDate}`
                    : `${ApiEndPoints?.topUpGroup}/${action.payload.groupId}?startDate=${action.payload.startDate}&endDate=${action.payload.endDate}`,
        });
        yield put(
            topUpGroupSuccess({
                topUpGroup: response.data,
            }),
        );
    } catch (err: any) {
        yield put(
            topUpGroupFailure({
                errorTopUpGroup: err.response && err.response.data,
            }),
        );
    }
}

// get credit referal
function* getCredit(action: any) {
    try {
        const response: ResponseGenerator = yield call(apiJunction.makeRequest, {
            method: 'get',
            url: `${ApiEndPoints.getCredit}/${action.payload.groupId}`,
        });
        yield put(
            getCreditSuccess({
                getCredit: response.data,
            }),
        );
    } catch (err: any) {
        yield put(
            getCreditFailure({
                errorGetCredit: err.response ? err.response.data : { status: 'FAILURE', message: 'error' },
            }),
        );
    }
}

// tax type 4
function* type4Tax(action: any) {
    try {
        const response: ResponseGenerator = yield call(apiJunction.makeRequest, {
            method: 'post',
            url: domainName === domainMap.T2 ? `${ApiEndPoints.type4Tax}` : `${ApiEndPoints.type4Tax}`,
            body: action.payload,
        });
        yield put(
            type4TaxSuccess({
                type4Tax: response.data,
            }),
        );
    } catch (err: any) {
        yield put(
            type4TaxFailure({
                errorType4Tax: err.response ? err.response.data : { status: 'FAILURE', message: 'error' },
            }),
        );
    }
}

// top up customer
function* topUpCustomer(action: any) {
    try {
        const response: ResponseGenerator = yield call(apiJunction.makeRequest, {
            method: 'post',
            url:
                domainName === domainMap.T2
                    ? `${ApiEndPoints.topUpCustomer}/${action.payload.taxInfo &&
                          action.payload.taxInfo.customerId}`
                    : `${ApiEndPoints.topUpCustomer}/${action.payload.taxInfo &&
                          action.payload.taxInfo.customerId}`,
            body: action.payload,
        });
        yield put(
            topUpCustomerSuccess({
                topUpCustomer: response.data,
            }),
        );
    } catch (err: any) {
        yield put(
            topUpCustomerFailure({
                errorTopUpCustomer: err.response ? err.response.data : { status: 'FAILURE', message: 'error' },
            }),
        );
    }
}

// top up customer status
function* topUpCustomerStatus(action: any) {
    try {
        const response: ResponseGenerator = yield call(apiJunction.makeRequest, {
            method: 'get',
            url: `${ApiEndPoints?.customerOperationStatus}/${action.payload.customerId}/topup`,
        });
        yield put(
            topUpCustomerStatusSuccess({
                topUpCustomerStatus: response.data,
            }),
        );
    } catch (err: any) {
        yield put(
            topUpCustomerStatusFailure({
                errorTopUpCustomerStatus: err.response ? err.response.data : { status: 'FAILURE', message: 'error' },
            }),
        );
    }
}

// buy data customer status
function* planChangeCustomerStatus(action: any) {
    try {
        const response: ResponseGenerator = yield call(apiJunction.makeRequest, {
            method: 'get',
            url: `${ApiEndPoints?.customerOperationStatus}/${action.payload.customerId}/planchange`,
        });
        yield put(
            planChangeCustomerStatusSuccess({
                planChangeCustomerStatus: response.data,
            }),
        );
    } catch (err: any) {
        yield put(
            planChangeCustomerStatusFailure({
                errorPlanChangeCustomerStatus: err.response
                    ? err.response.data
                    : { status: 'FAILURE', message: 'error' },
            }),
        );
    }
}

// referal credit
function* referalCredit() {
    try {
        const response: ResponseGenerator = yield call(apiJunction.makeRequest, {
            method: 'get',
            // url: `/confsvc/${version}/config/id/PROV_CONFIG/keys/REFERRER_DISC_IN_DOLLAR,REFEREE_DISC_IN_DOLLAR`,
            url: `${ApiEndPoints.referalCredit}`,
        });
        yield put(
            referalCreditSuccess({
                referalCredit: response.data,
            }),
        );
    } catch (err: any) {
        yield put(
            referalCreditFailure({
                errorReferalCredit: err.response && err.response.data,
            }),
        );
    }
}

// Change Plan
function* changePlan(action: any) {
    try {
        const response: ResponseGenerator = yield call(apiJunction.makeRequest, {
            method: 'post',
            url:
                domainName === domainMap.T2
                    ? `${ApiEndPoints.changePlan}`
                    : `${ApiEndPoints.changePlan}`,
            body: action.payload,
        });
        yield put(
            changePlanSuccess({
                changePlan: response.data,
            }),
        );
    } catch (err: any) {
        yield put(
            changePlanFailure({
                errorChangePlan: err.response ? err.response.data : { status: 'FAILURE', message: 'error' },
            }),
        );
    }
}

function* otp(action: any) {
    try {
        const response: ResponseGenerator = yield call(apiJunction.makeRequest, {
            method: 'post',
            url: `${ApiEndPoints.otp}`,
            body: action.payload,
        });
        yield put(
            otpSuccess({
                otp: response.data,
            }),
        );
    } catch (err: any) {
        yield put(
            otpFailure({
                errorOtp: err.response ? err.response.data : { status: 'FAILURE', message: 'error' },
            }),
        );
    }
}

function* accStatus(action: any) {
    try {
        const response: ResponseGenerator = yield call(apiJunction.makeRequest, {
            method: 'post',
            url: `${ApiEndPoints.accStatus}`,
            body: action.payload,
        });
        yield put(
            accStatusSuccess({
                accStatus: response.data,
            }),
        );
    } catch (err: any) {
        yield put(
            accStatusFailure({
                errorAccStatus: err.response ? err.response.data : { status: 'FAILURE', message: 'error' },
            }),
        );
    }
}

function* PostActivationSaga() {
    yield all([
        takeLatest(types.DATA_CUTOFF, dataCutOff),
        takeLatest(types.TOP_UP, topUp),
        takeLatest(types.TOP_UP_PULSE, topUpPulse),
        takeLatest(types.GROUPS, customerGroup),
        takeLatest(types.ACTIVATION_PRECHECK, activationPrecheck),
        takeLatest(types.TOP_UP_GROUPS, topUpGroup),
        takeLatest(types.GET_CREDIT, getCredit),
        takeLatest(types.TAX_4_TYPE, type4Tax),
        takeLatest(types.TOP_UP_CUSTOMER, topUpCustomer),
        takeLatest(types.REFERAL_CREDIT, referalCredit),
        takeLatest(types.CHANGE_PLAN, changePlan),
        takeLatest(types.TOP_UP_CUSTOMER_STATUS, topUpCustomerStatus),
        takeLatest(types.PLAN_CHANGE_CUSTOMER_STATUS, planChangeCustomerStatus),
        takeLatest(types.OTP, otp),
        takeLatest(types.ACC_STATUS, accStatus),
    ]);
}

export default PostActivationSaga;
